import history from "./history";

export const sleepByMs = async (durationMs) => {
  return new Promise(res => setTimeout(res, durationMs));
}

export const generateUuid = (): string => {
  /* eslint-disable */
  return ((([1e7] as unknown) as string) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    ((c as any) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & ((15 >> ((c as any) / 4)) as any))).toString(16)
  );
};

export const getMeasuredValDisplayedFloat = (measuredVal: number): number => {
  if (isNaN(measuredVal)) {
    return undefined;
  }

  return parseFloat(measuredVal.toFixed(measuredVal < 0.01 ? 5 : 2));
};

export const setQueryParams = (params: { [key: string]: string }, isReplace?: boolean) => {
  const url = new URL(window.location.href);

  for (const key in params) {
    url.searchParams.set(key, params[key]);
  }

  const newHistoryVal: string = url.pathname + url.search;

  if (isReplace) {
    history.replace(newHistoryVal);
  } else {
    history.push(newHistoryVal);
  }
};

export const clearQueryParams = (keys: string[], isReplace?: boolean) => {
  if (!keys || !keys.length) {
    return;
  }

  const url = new URL(window.location.href);

  keys.forEach(key => {
    url.searchParams.delete(key);
  });

  const newHistoryVal: string = url.pathname.replace(/\/$/, '') + url.search;

  if (isReplace) {
    history.replace(newHistoryVal);
  } else {
    history.push(newHistoryVal);
  }
};

export const getQueryParams = (keys: Array<string>): { [key: string]: string } => {
  const url = new URL(window.location.href);

  const params = {};
  keys.forEach(key => (params[key] = url.searchParams.get(key) ? url.searchParams.get(key) : null));

  return params;
};